<template>
  <div class="g-box">
    <!--ぱんくず-->
    <breadcrumb :pathList="pathList">
    </breadcrumb>
    <!--/ぱんくず-->
    <main class="g-content">
      <h1 class="g-h-1 g-rainbow">サイトマップ</h1>
        <section class="g-unit-xl">
          <p><b>トップページ</b></p>
          <ul class="g-list g-list-disc">
            <li><router-link class="g-link" :to="'/'">トップページ</router-link></li>
          </ul>
        </section>
        <section class="g-unit-xl">
          <p><b>プロジェクトから探す</b></p>
          <ul class="g-list g-list-disc">
            <li><router-link class="g-link" :to="'/search?dbs=taiwan'">台湾および周辺島嶼の物質文化</router-link></li>
            <li><router-link class="g-link" :to="'/search?dbs=georgebrown'">ジョージ・ブラウン・コレクション</router-link></li>
            <li><router-link class="g-link" :to="'/search?dbs=jpculture'">日本の文化展示関連情報データベース</router-link></li>
            <li><router-link class="g-link" :to="'/search?dbs=canada'">北米北方先住民関連文化資源データベース</router-link></li>
            <li><router-link class="g-link" :to="'/search?dbs=mepc'">中東地域民衆文化資料データベース</router-link></li>
          </ul>
        </section>
        <section class="g-unit-xl">
          <p><b>索引から探す</b></p>
          <ul class="g-list g-list-disc">
            <li><router-link class="g-link" :to="'/index/id'">標本番号</router-link></li>
            <li><router-link class="g-link" :to="'/index/name'">標本名</router-link></li>
            <li><router-link class="g-link" :to="'/index/age'">年代</router-link></li>
            <li><router-link class="g-link" :to="'/index/area'">地域名</router-link></li>
            <li><router-link class="g-link" :to="'/index/nation'">民族名</router-link></li>
            <li><router-link class="g-link" :to="'/index/owc'">地域・民族分類（OWC）</router-link></li>
            <li><router-link class="g-link" :to="'/index/ocm'">文化項目分類（OCM）</router-link></li>
            <li><router-link class="g-link" :to="'/index/fyear'">受入年</router-link></li>
          </ul>
        </section>
        <section class="g-unit-xl">
          <p><b>その他</b></p>
          <ul class="g-list g-list-disc">
            <li><router-link class="g-link" :to="'/about'">このサイトについて</router-link></li>
            <li><router-link class="g-link" :to="'/link'">関連リンク</router-link></li>
          </ul>
        </section>
    </main>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue'

export default {
  components: {
    breadcrumb
  },
  computed: {
    // パン屑リスト
    pathList: function() {
      return [
        { path: '/', text: 'Site.home' },
        { path: '/sitemap', text: 'Site.sitemap' },
      ]
    },
  }
}

</script>